'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var AvatarImage = require('./AvatarImage.js');
var AvatarBadge = require('./AvatarBadge.js');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["src", "name", "showBorder", "borderRadius", "onError", "getInitials", "loading", "borderColor", "status"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function defaultGetInitials(name) {
  var _name$split = name.split(' '),
    _name$split2 = _slicedToArray__default["default"](_name$split, 2),
    firstName = _name$split2[0],
    lastName = _name$split2[1];
  return firstName && lastName ? "".concat(firstName.charAt(0)).concat(lastName.charAt(0)) : firstName.charAt(0);
}
/**
 * Avatar
 *
 * Component that renders an user avatar with support for name-only avatars.
 *
 * @see Docs https://chakra-ui.com/avatar
 */
var Avatar = react.forwardRef(function (props, ref) {
  var styles = react.useMultiStyleConfig('Avatar', props);
  var _omitThemingProps = react.omitThemingProps(props),
    src = _omitThemingProps.src,
    name = _omitThemingProps.name,
    showBorder = _omitThemingProps.showBorder,
    _omitThemingProps$bor = _omitThemingProps.borderRadius,
    borderRadius = _omitThemingProps$bor === void 0 ? 'full' : _omitThemingProps$bor,
    onError = _omitThemingProps.onError,
    _omitThemingProps$get = _omitThemingProps.getInitials,
    getInitials = _omitThemingProps$get === void 0 ? defaultGetInitials : _omitThemingProps$get,
    loading = _omitThemingProps.loading,
    borderColor = _omitThemingProps.borderColor,
    status = _omitThemingProps.status,
    rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);
  var avatarStyles = _objectSpread({
    borderRadius: borderRadius,
    borderWidth: showBorder ? '2px' : undefined,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 'medium',
    position: 'relative',
    flexShrink: 0
  }, styles.container);
  if (borderColor) {
    avatarStyles.borderColor = borderColor;
  }
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.span, _extends__default["default"]({
    ref: ref
  }, rest, {
    className: utils.cx('chakra-avatar', props.className),
    __css: avatarStyles
  }), /*#__PURE__*/React__default["default"].createElement(react.StylesProvider, {
    value: styles
  }, /*#__PURE__*/React__default["default"].createElement(AvatarImage.AvatarImage, {
    src: src,
    loading: loading,
    onError: onError,
    getInitials: getInitials,
    name: name,
    borderRadius: borderRadius
  }), status && /*#__PURE__*/React__default["default"].createElement(AvatarBadge.AvatarBadge, null)));
});
Avatar.displayName = 'Avatar';
exports.Avatar = Avatar;